import constants from '../Constants';
const {
  GET_COMPANIES,
  COMPANIES_LOADING,
  ADD_COMPANY,
  ADD_COMPANY_FAIL,
  UPDATE_COMPANY,
  UPDATE_COMPANY_FAIL,
  DELETE_COMPANY,
  RESET_COMPANIES_ALERT,
  LOGOUT
} = constants;

const INIT_STATE = {
  companies:{},
  companiesMeta:{total: false, lastPage: false, currentPage: 1, perPage: 20},
  companiesLoading: true,
  alert: { add: false, delete: false, edit: false, get: false },
  query: {},
};

const CompanyReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_COMPANIES:
      const { data, query } = action.payload;
      const { entities, result } = data; 
      return { 
            ...state, 
            companies: entities.companies, 
            companiesMeta: {
                lastPage: result.last_page,
                total: result.total,
                currentPage: result.current_page,
                perPage: result.per_page,
                data: result.data,
            },
            companiesLoading: false,
            query: query,
        };

    case COMPANIES_LOADING:
        return {
            ...state, companiesLoading: true,
        };
    
    case DELETE_COMPANY:
        const { companiesMeta, companiesMeta: { data: metaData } } = state;

        const { [action.payload.toString()]: removed, ...rest } = state.companies;
        
        metaData.splice(metaData.indexOf(action.payload), 1);
        
        const newMeta = { ...companiesMeta, data: metaData };
        
        return { ...state, companies: rest, companiesMeta: newMeta };
    
    case ADD_COMPANY:

        return {
            ...INIT_STATE,
            alert: {...INIT_STATE.alert, add: { type: "success", message: "Company added successfully." }},
        };
    
    case ADD_COMPANY_FAIL:
        return {
            ...state,
            alert: {...INIT_STATE.alert, add: {type: "warning", message: action.payload }},
        };

    case UPDATE_COMPANY:
        const companies = {...state.companies,[action.payload.id]: action.payload};
        return {...state, companies,  alert: {...INIT_STATE.alert, edit: { type: "success", message: "Company updated successfully." }}};

    case UPDATE_COMPANY_FAIL:
        return {
            ...state,
            alert: {...INIT_STATE.alert, edit: { type: "warning", message: action.payload }},
        };

    case RESET_COMPANIES_ALERT:
        return {
            ...state,
            alert: INIT_STATE.alert,
        };

    case LOGOUT:
        return INIT_STATE;

    default:
        return state;

    }
}

export default CompanyReducer;


// WEBPACK FOOTER //
// ./src/Reducers/CompanyReducer.js